import * as React from 'react';
export const IcTariffAlert = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zm-5 3a5 5 0 011-3H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3V9.9A5 5 0 0114 5zm.5 9a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0114.5 19a.93.93 0 01-.45-.11l-4-2A1 1 0 0110.5 15h1a1 1 0 000-2h-2a1 1 0 010-2h5a1 1 0 010 2h-.18a3 3 0 01.18 1zm3.79-7.71A1 1 0 0018 7c.002.13.029.26.08.38.05.121.122.233.21.33.097.088.209.16.33.21a.94.94 0 00.76 0 1.15 1.15 0 00.33-.21A1 1 0 0020 7a1 1 0 00-1.71-.71z'
      fill='currentColor'
    />
  </svg>
);
